import { render, staticRenderFns } from "./customerOpen.vue?vue&type=template&id=32c6a2fc&scoped=true"
import script from "./customerOpen.vue?vue&type=script&lang=js"
export * from "./customerOpen.vue?vue&type=script&lang=js"
import style0 from "./customerOpen.vue?vue&type=style&index=0&id=32c6a2fc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32c6a2fc",
  null
  
)

export default component.exports